import { Helmet } from "react-helmet-async";
import { absUrl, AUTHOR, SITE_NAME } from "../site";

export default function Seo({
  title,
  description,
  path = "/",
  image = "/og/home.png",
  type = "website",
  published,
  tags = [],
}) {
  const url = absUrl(path);
  const imageUrl = absUrl(image);
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} · ${SITE_NAME}`;
  const jsonLd =
    type === "article"
      ? {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: title,
          description,
          image: [imageUrl],
          datePublished: published,
          author: { "@type": "Person", name: AUTHOR.name, url: absUrl("/") },
          publisher: { "@type": "Person", name: AUTHOR.name },
          mainEntityOfPage: url,
          keywords: tags.join(", "),
        }
      : {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: SITE_NAME,
          url: absUrl("/"),
          description,
        };

  return (
    <Helmet>
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
